import { NgModule } from '@angular/core';

import { ServicosComponent } from './servicos.component';
import {SharedModule} from "../../shared/shared.module";
import {ServicosRoutingModule} from "./servicos-routing.module";
import {ServicoFormComponent} from "./servico-form/servico-form.component";
import {ServicoListComponent} from "./servico-list/servico-list.component";
import {ServicoApiService} from "./shared/servico-api.service";
import {ServicoNavigationService} from "./shared/servico-navigation.service";
import {ServicoService} from "./shared/servico.service";
import {ServicoPlanoTableComponent} from "./servico-planos/servico-plano-table/servico-plano-table.component";
import {ServicoPlanoFormListComponent} from "./servico-planos/servico-plano-form-list/servico-plano-form-list.component";
import {ServicoBemListComponent} from "./servico-bens/servico-bem-list/servico-bem-list.component";
import {MateriaisModule} from "../../almoxarifado/materiais/materiais.module";
import {ServicoPlanoFormComponent} from "./servico-planos/servico-plano-form/servico-plano-form.component";
import {ServicoBemFormComponent} from "./servico-bens/servico-bem-form/servico-bem-form.component";

@NgModule({
    imports: [
        SharedModule,
        MateriaisModule,
        ServicosRoutingModule
    ],
    providers: [
        ServicoApiService,
        ServicoNavigationService,
        ServicoService
    ],
    declarations: [
        ServicosComponent,
        ServicoFormComponent,
        ServicoListComponent,
        ServicoPlanoTableComponent,
        ServicoPlanoFormListComponent,
        ServicoPlanoFormComponent,
        ServicoBemListComponent,
        ServicoBemFormComponent
    ],
    exports: [
        ServicoPlanoTableComponent,
        ServicoPlanoFormListComponent,
        ServicoPlanoFormComponent
    ]
})
export class ServicosModule { }



/** WEBPACK FOOTER **
 ** ./~/angular2-template-loader!./src/app/manutencoes/servicos/servicos.module.ts
 **/